export const getLoading = ({ loading = {} } = {}) => loading;

export default getLoading;
